import React from 'react';

import {
  initialState,
  VerifyBusinessAction,
  VerifyBusinessState,
} from '@/Screens/VerifyBusiness/reducer';
import { noop } from '@/utility/noop';
import { AsAnyActionArg } from '@/utility/reducers';

export const VerifyBusinessContext = React.createContext<
  [VerifyBusinessState, React.ActionDispatch<AsAnyActionArg<VerifyBusinessAction>>]
>([initialState, noop]);
